function parseVersion(value) {
    const match = /^(\d+)\.(\d+)\.(\d+)(?:-([0-9A-Za-z.-]+))?$/.exec(value.trim());
    if (!match) {
        return undefined;
    }
    return {
        major: Number.parseInt(match[1], 10),
        minor: Number.parseInt(match[2], 10),
        patch: Number.parseInt(match[3], 10),
        prerelease: match[4],
    };
}
export function compareExtensionVersions(left, right) {
    const a = parseVersion(left);
    const b = parseVersion(right);
    if (!a || !b) {
        return undefined;
    }
    for (const key of ['major', 'minor', 'patch']) {
        const delta = a[key] - b[key];
        if (delta !== 0) {
            return delta;
        }
    }
    if (a.prerelease === b.prerelease) {
        return 0;
    }
    if (a.prerelease === undefined) {
        return 1;
    }
    if (b.prerelease === undefined) {
        return -1;
    }
    return a.prerelease.localeCompare(b.prerelease);
}
export function isExtensionUpdateAvailable(installedVersion, latestVersion) {
    if (!installedVersion || !latestVersion) {
        return false;
    }
    const comparison = compareExtensionVersions(installedVersion, latestVersion);
    return comparison === undefined
        ? installedVersion.trim() !== latestVersion.trim()
        : comparison < 0;
}
